// extracted by mini-css-extract-plugin
export default {"statistic":"TeamStat_statistic__yxtAx","show":"TeamStat_show__WumPh","listMatches":"TeamStat_listMatches__KZNdl"};